import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as itemTypes from "../../constants/itemTypes";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as intergammaMachineActions from "../../actions/intergammaMachineActions";
import * as toDispenseTabActions from "../../actions/toDispenseTabActions";
import * as formatHelper from "../../helpers/formatHelper";
import * as getterHelper from "../../helpers/getterHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as validationHelper from "../../helpers/validationHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_ITEM_BY_BARCODE:
            if (!responseHelper.isGetItemByBarcodeFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            switch (response.data.itemType) {
                case itemTypes.USER:
                    let user = modelHelper.mapUserToObject(response.data.item);

                    return [
                        {
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_LOG_OUT
                            },
                            method: handlers.LOG_OUT,
                            tabId: 0
                        },
                        {
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_LOG_IN,
                                params: {
                                    userId: user ? user.id : null,
                                    userLocal: user ? user.local : null
                                }
                            },
                            method: handlers.LOG_IN,
                            tabId: 0
                        }
                    ];
                case itemTypes.ORDER_RECORD:
                    if (!responseHelper.isOrderRecordByBarcodeValid(response)) {
                        if (responseHelper.isHistoryOrderRecordByBarcodeValid(response)) {
                            return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                        }

                        return [messageHelper.getInvalidFormatMessage(response)];
                    }

                    if (state.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB) {
                        if (state.module.gammaSoftware) {
                            return [intergammaMachineActions.selectOrder(response.data.item.id)];
                        }

                        return [
                            toDispenseTabActions.getToDispenseOrderDetail(
                                state.navigation.activeTab,
                                response.data.item.id
                            )
                        ];
                    }

                    return [];
                case itemTypes.SERVIND_PRODUCTION_BCD:
                    if (state.toDispense.dispensedOrder === null) {
                        return [];
                    }

                    if (response.data.item.item === undefined || response.data.item.lot === undefined) {
                        return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                    }

                    if (state.toDispense.dispensedOrder.note !== response.data.item.item) {
                        return [messageHelper.getWarningMessageAction("flashMessage.itemNotFound")];
                    }

                    return [
                        {
                            type: actionTypes.TO_DISPENSE_SAVE_DISPENSED_ORDER_NOTE,
                            payload: {
                                note: response.data.item.item + "*" + response.data.item.lot
                            }
                        },
                        {
                            type: actionTypes.MACHINE_DIALOG_CONTINUE
                        }
                    ];
                default:
                    return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
            }
        case handlers.GET_FORMULA_ITEMS_BY_BARCODE:
            if (response.result !== resultCodes.RESULT_OK || response.data.item === undefined) {
                return [messageHelper.getFlashMessage(response)];
            }

            switch (response.data.itemType) {
                case itemTypes.COLOR:
                    let colorByBarcode = modelHelper.mapColorToObject(response.data.item);

                    if (colorByBarcode === null || !getterHelper.isFormulaTab(state.navigation.activeTabType)) {
                        return [];
                    }

                    let validColorDatabaseName = validationHelper.getValidItem(
                        state.server.databaseList,
                        response.data.databaseName
                    );

                    if (validColorDatabaseName === null) {
                        return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                    }

                    if (state.module.gammaSoftware) {
                        return [
                            {
                                type: actionTypes.SERVER_REQUEST,
                                payload: {
                                    type: methods.METHOD_SET_ACTIVE_DATABASE,
                                    params: {
                                        name: validColorDatabaseName,
                                        autologin: true
                                    }
                                },
                                method: handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE,
                                tabId: tabId,
                                next: [
                                    {
                                        type: actionTypes.SET_ACTIVE_TAB_SCENE,
                                        payload: {
                                            tabId: tabId,
                                            scene: componentTypes.COLOR_SCENE
                                        }
                                    },
                                    {
                                        type: actionTypes.SET_SEARCH_PANEL,
                                        payload: {
                                            tabId: tabId,
                                            product: null,
                                            fandeck: null,
                                            color: colorByBarcode,
                                            base: null,
                                            bipp: null
                                        }
                                    }
                                ]
                            }
                        ];
                    }

                    if (validColorDatabaseName !== state.server.activeDatabase.name) {
                        return [
                            messageHelper.getInfoMessageAction("flashMessage.colorFromInactiveDatabase", [
                                validColorDatabaseName
                            ])
                        ];
                    }

                    return [
                        {
                            type: actionTypes.SET_SEARCH_PANEL,
                            payload: {
                                tabId: tabId,
                                product: null,
                                fandeck: null,
                                color: colorByBarcode,
                                base: null,
                                bipp: null
                            }
                        }
                    ];
                case itemTypes.COLOR_IN_FANDECK:
                    let cifByBarcode = modelHelper.mapColorInFandeckToObject(response.data.item);

                    if (cifByBarcode === null) {
                        return [];
                    }

                    let validCifDatabaseName = validationHelper.getValidItem(
                        state.server.databaseList,
                        response.data.databaseName
                    );

                    if (validCifDatabaseName === null) {
                        return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                    }

                    if (state.module.gammaSoftware) {
                        return [
                            {
                                type: actionTypes.SERVER_REQUEST,
                                payload: {
                                    type: methods.METHOD_SET_ACTIVE_DATABASE,
                                    params: {
                                        name: validCifDatabaseName,
                                        autologin: true
                                    }
                                },
                                method: handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE,
                                tabId: tabId,
                                next: [
                                    {
                                        type: actionTypes.SET_ACTIVE_TAB_SCENE,
                                        payload: {
                                            tabId: tabId,
                                            scene: componentTypes.PRODUCT_SCENE
                                        }
                                    },
                                    {
                                        type: actionTypes.SET_SEARCH_PANEL,
                                        payload: {
                                            tabId: tabId,
                                            product: null,
                                            fandeck: cifByBarcode.fandeck,
                                            color: cifByBarcode.color,
                                            base: null,
                                            bipp: null
                                        }
                                    }
                                ]
                            }
                        ];
                    }

                    if (validCifDatabaseName !== state.server.activeDatabase.name) {
                        return [
                            messageHelper.getInfoMessageAction("flashMessage.colorFromInactiveDatabase", [
                                validCifDatabaseName
                            ])
                        ];
                    }

                    return [
                        {
                            type: actionTypes.SET_SEARCH_PANEL,
                            payload: {
                                tabId: tabId,
                                product: null,
                                fandeck: cifByBarcode.fandeck,
                                color: cifByBarcode.color,
                                base: null,
                                bipp: null
                            }
                        }
                    ];
                case itemTypes.BASE_IN_PRODUCT_PACKAGE:
                    let productByBarcode = modelHelper.mapBaseInProductPackageToObject(response.data.item);

                    if (productByBarcode === null) {
                        return [];
                    }

                    return [
                        {
                            type: actionTypes.SEARCH_PANEL_INIT,
                            payload: {
                                tabId: tabId,
                                type: componentTypes.MAIN_TAB,
                                local: state.searchPanel[tabId].local
                            }
                        },
                        {
                            type: actionTypes.SELECT_PRODUCT,
                            payload: {
                                tabId: tabId,
                                product: productByBarcode.product,
                                bipp: null,
                                autoselect: true,
                                resetFilter: true
                            }
                        }
                    ];
                case itemTypes.CUSTOMER:
                    let customerActions = [
                        {
                            type: actionTypes.MAIN_TAB_SET_CUSTOMER,
                            payload: {
                                tabId: tabId,
                                customer: modelHelper.mapCustomerToObject(response.data.item)
                            }
                        }
                    ];

                    if (state.navigation.activeTabType === componentTypes.ORDERS_HISTORY_TAB) {
                        customerActions.push({
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: handlers.INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID,
                                params: {
                                    customerId: response.data.item.id,
                                    dateFrom: formatHelper.formatDateTimeForServer(state.intergammaOrder.from),
                                    dateTo: formatHelper.formatDateTimeForServer(state.intergammaOrder.to)
                                }
                            },
                            method: handlers.INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID,
                            tabId: 0
                        });
                    }

                    return customerActions;
                case itemTypes.ORDER_RECORD:
                    if (!responseHelper.isHistoryOrderRecordByBarcodeValid(response)) {
                        if (responseHelper.isOrderRecordByBarcodeValid(response)) {
                            return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                        }

                        return [messageHelper.getInvalidFormatMessage(response)];
                    }

                    if (
                        state.formula[state.navigation.activeTab] === undefined ||
                        state.formula[state.navigation.activeTab].statisticsId !== null ||
                        state.searchPanel[state.navigation.activeTab] === undefined ||
                        state.searchPanel[state.navigation.activeTab].type ===
                            componentTypes.SEARCH_PANEL_COLOR_PALETTE ||
                        state.searchPanel[state.navigation.activeTab].type === componentTypes.SEARCH_PANEL_COLOR_SEARCH
                    ) {
                        return [messageHelper.getInfoMessageAction("flashMessage.openNewTab")];
                    }

                    let validDatabaseName = validationHelper.getValidItem(
                        state.server.databaseList,
                        response.data.item.stat.databaseName
                    );

                    let orderDetails = null;

                    if (state.module.gammaSoftware) {
                        if (validDatabaseName === null) {
                            return [messageHelper.getWarningMessageAction("customRedlikeMachine.unknownBrand")];
                        }
                        if (
                            Object.keys(response.data.item.formula.colorants).length === 0 &&
                            response.data.item.availableFormulas === null
                        ) {
                            return [messageHelper.getWarningMessageAction("flashMessage.barcodeNotFound")];
                        }

                        orderDetails = responseHelper.processDataFromBarcode(
                            response.data.item,
                            state.settings.shotsName !== null ? state.settings.shotsName : settings.UNIT_SHOT,
                            state.global.allColorantList,
                            state.settings.colorantPanelOrderBy,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        );
                    } else {
                        if (validDatabaseName !== state.server.activeDatabase.name) {
                            return [
                                messageHelper.getInfoMessageAction("ordering.inactiveDatabase", [validDatabaseName])
                            ];
                        }

                        orderDetails = responseHelper.processDataFromStatDetails(
                            response.data.item,
                            state.settings.shotsName !== null ? state.settings.shotsName : settings.UNIT_SHOT,
                            state.global.colorantList,
                            state.settings.colorantPanelOrderBy,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans,
                            state.settings.tintometricSystemsEnabled,
                            state.settings.generateColorPreview
                        );
                    }

                    let blendedColor = null;

                    if (orderDetails.color !== null) {
                        blendedColor = orderDetails.color.updateLongDisplayName(
                            state.settings.blendFormulaAndCode,
                            state.settings.formulaCodePrimary
                        );
                    }

                    let orderRequests = [
                        {
                            type: actionTypes.SAVE_FORMULA_DATA_FROM_STATS,
                            payload: {
                                tabId: tabId,
                                ...orderDetails
                            }
                        },
                        {
                            type: actionTypes.CONSTRUCT_SEARCH_PANEL,
                            payload: {
                                tabId: tabId,
                                product: orderDetails.product,
                                fandeck: orderDetails.fandeck,
                                color: blendedColor,
                                base: orderDetails.base,
                                bipp: orderDetails.bipp,
                                bippList: orderDetails.packageList
                            }
                        },
                        {
                            type: actionTypes.RELOAD_FORMULA_META_DATA,
                            payload: {
                                tabId: tabId
                            }
                        }
                    ];

                    if (orderDetails.formula !== null) {
                        orderRequests.push({
                            type: actionTypes.MACHINE_VALIDATE_DISPENSED_FORMULA,
                            payload: {
                                tabId: tabId,
                                formula: orderDetails.formula.getColorantVolumes(),
                                numCanDone: orderDetails.numCanDone,
                                numCanTotal: orderDetails.numCanTotal,
                                customCan: orderDetails.package?.isCustom() ?? false
                            }
                        });
                    }

                    if (state.module.gammaSoftware) {
                        orderRequests.push({
                            type: actionTypes.SAVE_PROCESSED_COMPATIBLE_SERVER_LIST,
                            payload: {
                                compatibleServerList: orderDetails.compatibleServerList
                            }
                        });
                        orderRequests.push({
                            type: actionTypes.INTERGAMMA_SAVE_ORDER_BARCODE,
                            payload: {
                                barcode: response.data.barcode
                            }
                        });
                        orderRequests.push({
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_SET_ACTIVE_DATABASE,
                                params: {
                                    name: validDatabaseName,
                                    autologin: true
                                }
                            },
                            method: handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE,
                            tabId: tabId
                        });
                    } else {
                        if (
                            orderDetails.base !== null &&
                            orderDetails.product !== null &&
                            orderDetails.package !== null
                        ) {
                            orderRequests.push({
                                type: actionTypes.SERVER_REQUEST,
                                payload: {
                                    type: methods.METHOD_GET_PRODUCT_IMAGE,
                                    params: {
                                        productName: orderDetails.product.name,
                                        baseName: orderDetails.base.name,
                                        packageName: orderDetails.package.name,
                                        online: state.settings.imagesSource === settings.SOURCE_ONLINE
                                    }
                                },
                                method: handlers.GET_PRODUCT_IMAGE,
                                tabId: tabId
                            });
                        }

                        orderRequests.push({
                            type: actionTypes.SET_ACTIVE_TAB_SCENE,
                            payload: {
                                tabId: tabId,
                                scene: componentTypes.SUMMARY_SCENE
                            }
                        });
                    }

                    return orderRequests;
                case itemTypes.FORMULA_COMBINATION:
                case itemTypes.FORMULA_COMBINATION_FOR_BIPP:
                    let formulaCombination = modelHelper.mapFormulaCombination(response.data.item);

                    if (formulaCombination === null) {
                        return [];
                    }

                    return [
                        {
                            type: actionTypes.SET_SEARCH_PANEL,
                            payload: {
                                tabId: tabId,
                                product: formulaCombination.product,
                                fandeck: formulaCombination.fandeck,
                                color: formulaCombination.color,
                                base: formulaCombination.base,
                                bipp: formulaCombination.bipp
                            }
                        }
                    ];
                default:
                    return [];
            }
        case handlers.GET_ITEM_BY_BARCODE_TEST:
            if (response.result === resultCodes.RESULT_BARCODE_NOT_FOUND) {
                return [
                    {
                        type: actionTypes.SAVE_BARCODE_ITEM,
                        payload: {
                            itemType: -1,
                            item: null
                        }
                    },
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_CANISTER_BY_BARCODE,
                            params: {
                                barcode: state.barcode.barcode
                            }
                        },
                        method: handlers.MACHINE_GET_CANISTER_BY_BARCODE_TEST,
                        tabId: 0,
                        safe: true
                    }
                ];
            }

            if (!responseHelper.isGetItemByBarcodeFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let barcodeItem = modelHelper.mapBarcodeItemToObject(response.data.itemType, response.data.item);

            let barcodeTestActions = [
                {
                    type: actionTypes.SAVE_BARCODE_ITEM,
                    payload: {
                        itemType: response.data.itemType,
                        item: barcodeItem
                    }
                }
            ];

            if (response.data.itemType === itemTypes.BASE_IN_PRODUCT_PACKAGE && barcodeItem !== null) {
                barcodeTestActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRODUCT_IMAGE,
                        params: {
                            productName: barcodeItem.product.name,
                            baseName: barcodeItem.base.name,
                            packageName: barcodeItem.package.name,
                            online: state.settings.imagesSource === settings.SOURCE_ONLINE
                        }
                    },
                    method: handlers.GET_BARCODE_TEST_MODAL_PRODUCT_IMAGE,
                    tabId: 0
                });
            }

            if (response.data.itemType === itemTypes.COLORANT_PACKAGE && barcodeItem !== null) {
                barcodeTestActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_COLORANT_PACKAGE_IMAGE,
                        params: {
                            colorantPackageId: response.data.item.id,
                            online: state.settings.imagesSource === settings.SOURCE_ONLINE
                        }
                    },
                    method: handlers.GET_BARCODE_TEST_MODAL_COLORANT_PACKAGE_IMAGE,
                    tabId: 0
                });
            }

            return barcodeTestActions;
        case handlers.GET_BASE_IN_PRODUCT_PACKAGE_BARCODES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_DIALOG
                        },
                        method: handlers.MACHINE_GET_DIALOG_AND_CONTINUE,
                        tabId: 0,
                        safe: false
                    }
                ];
            }

            if (
                response.data === undefined ||
                response.data.barcodes === undefined ||
                !Array.isArray(response.data.barcodes) ||
                response.data.barcodes.length === 0
            ) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_GET_DIALOG
                        },
                        method: handlers.MACHINE_GET_DIALOG_AND_CONTINUE,
                        tabId: 0,
                        safe: true
                    }
                ];
            }

            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_DIALOG
                    },
                    method: handlers.MACHINE_GET_DIALOG_AND_SKIP_BARCODE,
                    tabId: 0,
                    safe: false
                }
            ];
        case handlers.VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data !== undefined && response.data.valid === true) {
                return [
                    {
                        type: actionTypes.MACHINE_DIALOG_CONTINUE
                    }
                ];
            }

            return [messageHelper.getWarningMessageAction("flashMessage.incompatibleBaseCan")];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
